import type {SyncIntegration} from '@cohort/merchants/apps';
import BazaarvoiceSyncConfigComponent from '@cohort/merchants/apps/bazaarvoice/sync/SyncConfigComponent';
import type {BazaarvoiceSyncStruct} from '@cohort/shared/apps/bazaarvoice/sync';
import {BazaarvoiceSyncSpec} from '@cohort/shared/apps/bazaarvoice/sync';

export const BazaarvoiceSyncIntegration: SyncIntegration<BazaarvoiceSyncStruct> = {
  spec: BazaarvoiceSyncSpec,
  syncConfigComponent: BazaarvoiceSyncConfigComponent,
};
